import { ISelectModel } from 'common/models';

export const selectFieldCheckedFirst = ({
  listOfIds,
  selectFieldArray,
}: {
  listOfIds: string[] | undefined;
  selectFieldArray: ISelectModel<string>[] | undefined;
}) => {
  if (!listOfIds || !selectFieldArray) return undefined;

  const filteredEmployeesFromApi: ISelectModel<string>[] = [];

  listOfIds?.forEach((employeeId: string) => {
    const findEmployee = selectFieldArray?.find(item => item.value === employeeId);
    filteredEmployeesFromApi.push({ ...findEmployee, checked: true } as ISelectModel<string>);
  });

  const originalFilteredEmployees = selectFieldArray?.filter(
    item => !filteredEmployeesFromApi.some(employer => employer.value === item.value),
  ) as ISelectModel<string>[];

  return [...filteredEmployeesFromApi, ...originalFilteredEmployees];
};
